<template>
  <div class="background">
    <Title :message="'OUR SERVICES'" :isDark="true" />
    <div class="bottom">
      <div class="text sans">
        <div class="title kl-title">FIGTREE BIBLE</div>
        <div class="desc serif kl-description">
          성경 연구와 묵상을 위한<br>
          가장 간편하고 똑똑한 모바일 앱
        </div>
      </div>
      <div class="app-store">
        <a href="https://itunes.apple.com/kr/app/%EB%89%B4-%ED%94%BD%ED%8A%B8%EB%A6%AC%EC%84%B1%EA%B2%BD/id1117748316?mt=8" target="#">
          <img class="link" src="../assets/figtree_appstore.png" alt="">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.heavenlyspy.newfigtreebible" target="#"><img class="link" src="../assets/figtree_android.png" alt=""></a>
      </div>
    </div>
  </div>
</template>

<script>
import Title from './Title.vue'
export default {
  components: {
    Title
  }
}
</script>


<style lang="scss" scoped>
.background {
  position: relative;
  min-height: 720px;
  background: url('../assets/figtree_background.png') center center no-repeat;
  background-color: #dadbdf;
  .bottom {
    position: absolute;
    bottom: 0px;
    left: 0px;
    .app-store {
      margin-top: 65px;
      margin-left: 52px;
      margin-bottom: 42px;
      text-align: left;
      .link {
        height: 60px;
        margin-right: 12px;
      }
    }
    .text {
      margin-left: 52px;
      .title {
        font-weight: 500;
        letter-spacing: -4px;
        text-align: left;
        color: #262728;
      }
      .desc {
        letter-spacing: -3.5px;
        text-align: left;
        color: #262728;
      }
    }
  }
}
@media screen and (max-width: 640px) {
.background {
  min-height: 400px;
  .bottom {
    .app-store {
      margin-left: 16px;
      margin-top: 25px;
      .link {
        height: 40px;
        margin-right: 12px;
      }
    }
    .text {
      margin-left: 16px;
      .title {
        letter-spacing: -2.5px;
      }
      .desc {
        letter-spacing: -2px;
      }
    }
  }
}
}
</style>

